module.exports = __webpack_public_path__ + "static/kapiti-logo-e4c2ba7ca6e2cc0ae8b0b3f80ae52e9f.png";